import React from "react";
import HomeData from "../../../data/home.json";
import Intro from "../../../components/intro";

const IntroContainer = () => {
    const slides = HomeData[1].slider || [];
    return (
        <div className="hero-slider-area">
            {slides[0] && <Intro data={slides[0]} />}
        </div>
    );
};

export default IntroContainer;
